import { render, staticRenderFns } from "./FormDualStreamRecordStreamax.vue?vue&type=template&id=0c383e04&scoped=true&"
import script from "./FormDualStreamRecordStreamax.vue?vue&type=script&lang=ts&"
export * from "./FormDualStreamRecordStreamax.vue?vue&type=script&lang=ts&"
import style0 from "./FormDualStreamRecordStreamax.vue?vue&type=style&index=0&id=0c383e04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c383e04",
  null
  
)

export default component.exports